const industries = [
  "Bookkeeping firms",
  "Fractional CFOs",
  "Tax practices",
  "Outsourced accounting",
  "Advisory groups",
  "Payroll specialists",
  "Audit & assurance",
  "QuickBooks ProAdvisors",
  "Xero partners",
  "Wealth & finance",
];

export default function LogoMarquee() {
  return (
    <section data-testid="industries-marquee" className="py-12 border-b border-[#E4E4E7] bg-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 mb-6 flex items-center gap-3">
        <span className="w-2 h-2 bg-[#3FA742] inline-block" />
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0]">
          Industries we serve
        </p>
      </div>
      <div className="relative">
        <div className="flex w-max keepsy-marquee gap-12 px-10">
          {[...industries, ...industries].map((name, i) => (
            <div
              key={i}
              className="flex items-center gap-3 whitespace-nowrap"
            >
              <span className="w-1 h-6 bg-[#1F4DA0] inline-block" />
              <span className="font-display font-extrabold text-xl tracking-tight text-[#09090B]">
                {name}
              </span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
}
